module.exports = __webpack_public_path__ + "static/media/gb.5025b619.svg";